// 报损报溢单
export default {
  //查询报损报溢单列表
  GET_LIST_API: '/warehouse/overFlow/selectOverFlowListByPage',
  //保存
  SAVE_API: '/warehouse/overFlow/insertOverFlow',
  //提交
  SUBMIT_API: '/warehouse/overFlow/submitToApproval',
  //删除
  DEL_API: 'warehouse/overFlow/deleteoverFlow/',
  //详情
  DETAIL_API: '/warehouse/overFlow/selectOverFlowListById/',
  /**业务入库批次列表 */
  LIST_INBOUND: '/warehouse/storageBatch/listStorageBatchByPublic',
  /** 根据单价和数量计算金额 */
  GET_AMOUNT: '/sales/orderSalesReturn/getReturnMoneyAmount',
  /** 根据损溢数和批次初次入库数计算损溢比例 */
  GET_SCALE: '/warehouse/overFlow/overFlowCalculate',
  /** 撤销 */
  REVOKE_API: '/warehouse/storageAllot/revoke',
  /** 合同行项目详情 */
  CONTRSACT_DETAIL: '/sales/orderDetail/getOrderDetail',
  /** 业务入库批次列表  */
  GET_INBOUND: '/warehouse/storageBatch/listStorageBatchWithInbound',
  /** 业务入库批次列表--  */
  GET_INBOUND_NEW: '/warehouse/storageBatch/queryStorageForPurchaseReturnPage',
  // ============ sunxueping 批量过帐 ============
  BATCH_SYN_VOUCHER: '/warehouse/overFlow/batchSyncVoucher',
  // 批量标记过账
  BATCH_SYN_SIGN_VOUCHER: '/warehouse/overFlow/batchSignSyncVoucher',
  // ================================================
  // 确认
  DO_CONFIRM: '/warehouse/overFlow/doConfirm',
};
